import { translateParts } from 'aos-helpers/src/helpers/translations/Translations'
import {
    recurrenceCustomOns,
    RecurrenceCustomOnValue,
    recurrenceCustomOnValues,
} from 'aos-services/src/services/tasks/types/payload/RecurrencePayloadEnums'
import { TaskRecurrenceMonthlyPayload } from 'aos-services/src/services/tasks/types/payload/TaskRecurrenceMonthlyFormPayload'
import { TaskRecurrenceYearlyPayload } from 'aos-services/src/services/tasks/types/payload/TaskRecurrenceYearlyFormPayload'
import { TaskRecurrenceType } from 'aos-services/src/services/tasks/types/task/TaskRecurrenceType'
import { Box, Dropdown, HStack, MultiSelect } from 'aos-ui-universal'
import React, { FC } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { NumberRowField } from './NumberRowField'
import { TaskRecurrenceFormProps } from './TaskRecurrenceFormProps'

export const RecurrenceCustomOnComponent: FC<RecurrenceCustomOnComponentProps> = ({
    value,
    onChange,
    errors,
    canEdit,
}) => {
    const { t: translate } = useTranslation()
    if (value?.type !== TaskRecurrenceType.Monthly && value?.type !== TaskRecurrenceType.Yearly) {
        return null
    }
    const recurrenceErrors = errors as
        | FieldErrors<TaskRecurrenceMonthlyPayload | TaskRecurrenceYearlyPayload>
        | undefined
    const isCustomOn = value.customOn !== undefined && value.customOn !== null
    const selectedValues = value.customOnValue ?? []

    const changeCustomOnValue = (next: string[]) => {
        let customOnValue = next as RecurrenceCustomOnValue[]
        if (
            selectedValues.includes(RecurrenceCustomOnValue.DAY) ||
            !customOnValue.includes(RecurrenceCustomOnValue.DAY)
        ) {
            customOnValue = customOnValue.filter(i => !i.includes(RecurrenceCustomOnValue.DAY))
        } else {
            customOnValue = customOnValue.filter(i => i.includes(RecurrenceCustomOnValue.DAY))
        }
        onChange({ customOnValue })
    }

    return (
        <NumberRowField
            prefixLabel={translate('on', { ns: 'tasks' })}
            error={
                recurrenceErrors?.customOnValue
                    ? translate('custom-on.error', { ns: 'tasks' })
                    : undefined
            }
            className='shrink-0 flex-1 gap-1'
        >
            <HStack className='shrink-0 flex-1 items-center gap-1'>
                <Box className='w-24 shrink-0'>
                    <Dropdown
                        value={value.customOn}
                        items={recurrenceCustomOns}
                        labelRenderer={customOn =>
                            translateParts(translate)('tasks.recurrence-custom-on.' + customOn)
                        }
                        onChange={customOn => customOn && onChange({ customOn })}
                        hasClear={false}
                        disabled={!canEdit || !isCustomOn}
                    />
                </Box>
                <Box className='min-w-0 flex-1'>
                    <MultiSelect
                        options={recurrenceCustomOnValues.map(customOnValue => ({
                            value: customOnValue,
                            label: translateParts(translate)(
                                'tasks.recurrence-custom-on-value.' + customOnValue,
                            ),
                        }))}
                        value={selectedValues}
                        onChange={changeCustomOnValue}
                        summary={selected =>
                            `${selected.length}/${recurrenceCustomOnValues.length}`
                        }
                        size='md'
                        disabled={!canEdit || !isCustomOn}
                        className='min-w-0'
                    />
                </Box>
            </HStack>
        </NumberRowField>
    )
}

export type RecurrenceCustomOnComponentProps = TaskRecurrenceFormProps
